import axios from "../http";

class Cost {
  //快递列表
  getCostPrice(startTime, endTime, A, a, b) {
    const url = `/zwy/api/order/calculate?startTime=${startTime}&endTime=${endTime}&A=${A}&a=${a}&b=${b}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Cost;
